<script lang="ts" setup>
	import BaseModal from '@/components/modals/BaseModal.vue';
	import type {AlternativePFGroup} from '@/types/AlternativePFGroup.ts';
	import type {AlternativeForm} from 'dummen-shared';
	import {ref} from 'vue';
	import {useI18n} from 'vue-i18n';

	const {t} = useI18n();

	const props = defineProps<{
		group: AlternativePFGroup;
	}>();

	const emits = defineEmits<{
		close: [];
		confirm: [selectedForm: AlternativeForm];
	}>();

	const selectedFormId = ref(props.group.alternativeForms[0]?.formId ?? '');

	const close = () => emits('close');
	const confirm = () => {
		const selectedForm = props.group.alternativeForms.find(form => form.formId === selectedFormId.value);
		if (selectedForm) {
			emits('confirm', selectedForm);
		}
	};
</script>

<template>
	<base-modal :cancel-button-text="t('shoppingcart.modal.alternativePF.cancel.text')"
	            :confirm-button-text="t('shoppingcart.modal.alternativePF.confirm.text')"
	            confirm-button-class="button--orange"
	            @cancel="close"
	            @confirm="confirm">
		<template v-slot:title>
			{{ t('shoppingcart.modal.alternativePF.title') }}
		</template>

		<p>
			{{ t('shoppingcart.modal.alternativePF.prefix.text', {groupName: group.groupName, formName: group.formName}) }}
		</p>
		<p>{{ t('shoppingcart.modal.alternativePF.select.text') }}</p>

		<select v-model="selectedFormId" class="alternative-pf-modal__select">
			<option v-for="pf in group.alternativeForms" :key="pf.formId" :value="pf.formId">{{ pf.formName }}</option>
		</select>
	</base-modal>
</template>

<style scoped>
	.alternative-pf-modal__select {
		display: block;
		width: 100%;
		border: #ebebeb 3px solid;
		font-weight: 500;
		color: #595959;
		line-height: 32px;
		-webkit-appearance: none;
		-moz-appearance: none;
		background: #ffffff url("/assets/images/build/icons/icon-caret-down.svg?inline") no-repeat;
		background-position-x: 100%;
		background-position-y: 5px;
		padding: 0 2rem 0 10px;
	}
</style>

